import { render, staticRenderFns } from "./MonitoringPrice.vue?vue&type=template&id=ceac1136&scoped=true"
import script from "./MonitoringPrice.vue?vue&type=script&lang=ts"
export * from "./MonitoringPrice.vue?vue&type=script&lang=ts"
import style0 from "./MonitoringPrice.vue?vue&type=style&index=0&id=ceac1136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceac1136",
  null
  
)

export default component.exports